import React from 'react';
import { Avatar, Box, Divider, List, ListItem, ListItemButton, ListItemText, Typography, } from '@mui/material';
import BasePopover from '../popover/base-popover.component';
import { cleanAccountCache } from '../../constants/tool.check-token';
import { Person2Outlined, ExitToAppOutlined } from '@mui/icons-material';
import i18n from '../../i18n';
import { observer } from 'mobx-react-lite';
import { accountState } from '../../page/my-account/account-state';
import { createHashHistory } from 'history';

export default observer(function ToolBarAvatar({ isHiddenText }: {
    isHiddenText: boolean
}) {
    const [accountAnchorEl, setAccountAnchorEl] = React.useState<HTMLElement | null>(null);
    const { first_name, last_name, account_type } = accountState.userInfo || {};
    const name = `${first_name || ''} ${last_name || ''}`;

    return (
        <Box className='tool-bar-button'>
            <Box
                display='flex'
                alignItems='center'
                gap='10px'
                onClick={(event: { currentTarget: any; }) => {
                    setAccountAnchorEl(event.currentTarget);
                }}
                sx={{ cursor: 'pointer', width: '100%' }}
            >
                <Avatar
                    className='app-bar-avatar'
                    alt={name}
                    src={accountState.userInfo?.avatar} />

                {
                    isHiddenText &&
                    <Typography variant='body2'>
                        {name}
                    </Typography>
                }

            </Box>
            <BasePopover
                open={Boolean(accountAnchorEl)}
                anchorEl={accountAnchorEl}
                onClose={() => { setAccountAnchorEl(null) }}
                id='account-popover'
            >
                <Box minWidth={200}>
                    <List  >
                        <ListItem >
                            <ListItemText
                                primary={
                                    <div className='FCS'>
                                        <Avatar
                                            className='app-bar-avatar'
                                            alt={name}
                                            src={accountState.userInfo?.avatar} />
                                        <Box marginLeft={'0.625rem'}>
                                            <Typography variant='body1' fontWeight={600}>
                                                {name}
                                            </Typography>
                                            <Typography variant='body2' >
                                                {account_type}
                                            </Typography>
                                        </Box>
                                    </div>
                                }
                                color='primary'
                            />
                        </ListItem>
                        <Divider style={{ marginBottom: 8 }} />
                        <ListItemButton disableGutters={false}
                            onClick={() => {
                                createHashHistory().push('/main/account');
                            }}
                        >
                            <ListItemText
                                primary={
                                    <div className='FCS'>
                                        <Person2Outlined style={{ marginRight: '8px', fontSize: 18 }} />
                                        <Typography >
                                            {i18n.t('main_page_text_person_page')}
                                        </Typography>
                                    </div>
                                }
                                color='primary'
                            />
                        </ListItemButton>
                        <ListItemButton disableGutters={false}
                            onClick={() => {
                                cleanAccountCache(true);
                            }}
                        >
                            <ListItemText
                                primary={
                                    <div className='FCS'>
                                        <ExitToAppOutlined style={{ marginRight: '8px', fontSize: 18 }} />
                                        <Typography >
                                            {i18n.t('main_page_button_sign_out')}
                                        </Typography>
                                    </div>
                                }
                                color='primary'
                            />
                        </ListItemButton>
                    </List>
                </Box>
            </BasePopover>
        </Box>
    )
})